import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export const articlesPreview = () => {

	let el = document.querySelector('[data-animation="articles-preview"]')

	if (!el || window.innerWidth < 1280) return

	let items = el.querySelectorAll('.articles-item'),
		offsets = [80, 160, 320, 240]

	items.forEach((item, index) => {
		gsap.fromTo(item, {
			y: offsets[index % offsets.length],
		}, {
			y: 0,
			ease: "none",
			scrollTrigger: {
				trigger: el,
				start: "top bottom",
				end: "top 40%",
				scrub: true,
				// markers: true,
			}
		})
	})

}

export default () => { }